module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/elevate-93ccf7f90a8513a244a83c87972c5b04.png";